import filterLoans from "../libs/filterLoans";

export default {
  amount : window.slider_amounts || [
    2000,
    4000,
    6000,
    8000,
    10000,
    12000,
    14000,
    16000,
    18000,
    20000,
    22000,
    24000,
    26000,
    28000,
    30000,
    35000,
    40000,
    45000,
    50000,
    55000,
    60000,
    65000,
    70000,
    75000,
    80000,
    85000,
    90000,
    95000,
    100000,
    105000,
    110000,
    115000,
    120000,
    125000,
    130000,
    135000,
    140000,
    145000,
    150000,
    155000,
    160000,
    165000,
    170000,
    175000,
    180000,
    185000,
    190000,
    195000,
    200000,
    210000,
    220000,
    230000,
    240000,
    250000,
    260000,
    270000,
    280000,
    290000,
    300000,
    310000,
    320000,
    330000,
    340000,
    350000,
    360000,
    370000,
    380000,
    390000,
    400000,
    410000,
    420000,
    430000,
    440000,
    450000,
    460000,
    470000,
    480000,
    490000,
    500000,
  ],
  repayment : window.slider_periods || [
    12,
    24,
    36,
    48,
    60,
    72,
    84,
    96,
    108,
    120,
    132,
    144,
  ],
  default: {
    amount:  window.default_slider_amount || window.default_slider_amount || 150000,
    repayment: window.default_slider_period || window.default_slider_period || 96,
  },
  onChange(slider) {
    slider.link.setAttribute('href', slider.calculator.amount < 50000? `/snabblan/?amount=${slider.calculator.amount}&repayment=${slider.calculator.repayment}#loan-list`: '#loan-list')


    filterLoans(window.loan_lists[0], slider)
  },
}



// WEBPACK FOOTER //
// ./scripts/Data/private-loan.js